module.exports = __webpack_public_path__ + "img/revoked.2f20a417.png";